import type { ReactElement } from 'react';
import { useNotificationSettingsQuery } from '@/entities/notification';
import { EmptyState } from '@/shared/ui';
import { KindSettingsSection } from './kind-settings-section';
import { OperatorRecipientsSection } from './operator-recipients-section';

/**
 * 알림 설정(/notifications/settings, 알림 설계 §6-2) — 알림 유형별 발송(ON/OFF)과 알림 받을 담당자를 한 번의 조회로 보인다.
 * 바꾼 설정은 재배포 없이 다음 발송부터 적용된다(worker 가 보내기 직전에 읽는다).
 */
export const NotificationSettingsPanel = (): ReactElement => {
  const settingsQuery = useNotificationSettingsQuery();

  if (settingsQuery.isPending) {
    return <EmptyState>알림 설정을 불러오는 중…</EmptyState>;
  }

  if (settingsQuery.isError) {
    return (
      <EmptyState isError>
        {`알림 설정을 불러오지 못했습니다: ${settingsQuery.error.message}`}{' '}
        <button type="button" className="underline" onClick={() => void settingsQuery.refetch()}>
          다시 시도
        </button>
      </EmptyState>
    );
  }

  const { kinds, operatorRecipients, operatorFallbackConfigured } = settingsQuery.data;

  return (
    <div className="flex flex-col gap-6">
      <KindSettingsSection kinds={kinds} />
      <OperatorRecipientsSection
        recipients={operatorRecipients}
        fallbackConfigured={operatorFallbackConfigured}
      />
    </div>
  );
};
